import { Box, Flex, Icon, Text, Tooltip } from '@chakra-ui/react';
import type { ElementType } from 'react';
import { ChevronRight } from '@kula-ai/icons-core';

interface NavButtonProps {
  icon?: ElementType;
  title?: string;
  count?: number;
  arrow?: boolean;
  active?: boolean;
  isCollapsed?: boolean;
}

export const NavButton = ({
  icon,
  title,
  count = 0,
  arrow = false,
  active = false,
  isCollapsed,
}: NavButtonProps) => {
  return (
    <Tooltip
      isDisabled={!isCollapsed}
      label={title}
      arrowSize={8}
      hasArrow
      placement="right"
      borderRadius="4px"
      variant="default"
    >
      <Flex
        alignItems="center"
        cursor="pointer"
        p="8px 6px 8px 12px"
        borderRadius="6px"
        mb="2px"
        minH="42px"
        _hover={{ bg: 'white' }}
        bg={active ? 'white' : undefined}
      >
        <Icon
          className="primary-900"
          as={icon}
          width="18px"
          height="18px"
          mr="10px"
        />
        {!isCollapsed && (
          <Text
            flex="1"
            size="sm-regular"
            color="primary-900"
            fontSize="14px"
            fontWeight={active ? 650 : 450}
          >
            {title}
          </Text>
        )}
        {isCollapsed && count > 0 && (
          <Box
            bg="#444CE7"
            padding="3px"
            borderRadius="100%"
            position="relative"
            left="-8px"
            top="-3px"
          ></Box>
        )}
        {!isCollapsed && count > 0 && (
          <Flex
            bg="primary-100"
            color="primary-700"
            px="8px"
            py="4px"
            mr="5px"
            h="24px"
            minW="24px"
            borderRadius="full"
            fontSize="xs"
            alignItems="center"
            justifyContent="center"
            fontWeight="semiBold"
          >
            {count}
          </Flex>
        )}
        {arrow && <Icon ml="14px" as={ChevronRight} />}
      </Flex>
    </Tooltip>
  );
};
